export default __webpack_public_path__ + "static/dbd-639c1624f397fd334e5fbf063f764274.jpg";